import moment from 'moment'
const RANGES = [
  '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
  '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
  '\ud83d[\ude80-\udeff]', // U+1F680 to U+1F6FF
  '[\uE000-\uF8FF]'
]
const EMOJI_RANGE_REGEX = new RegExp(RANGES.join('|'), 'g')
export default {
  data() {
    return {
      apiPath: '/master/item'
    }
  },
  methods: {
    setRemitQuery(querystr) {
      if (querystr.indexOf('limit') === -1) {
        querystr += querystr.indexOf('?') === -1 ? `?limit=50` : `&limit=50`
      }
      return querystr
    },
    startParse: function(start) {
      return moment(start).format('YYYY-MM-DD')
    },
    removeEmoji(inputValue) {
      if (inputValue) {
        return inputValue.replace(EMOJI_RANGE_REGEX, '')
      }
      return inputValue
    },

    /**
     * 日付を文字列型から数値型に変換する
     * @param {string} paramDate 日付文字列です
     */
    convertDateToTime(paramDate = '') {
      if (!paramDate) {
        return 0
      }
      const [year, month, day] = paramDate.split('-')
      const date = new Date(+year, month - 1, +day)
      return Math.floor(date.getTime() / 1000)
    },
    /**
    * ユーザーが選択した値ごとにシュート レイヤー ラベルを表示する
    * @param {number} value 選択されたユーザー値
    * @param {array} chuteSelectOptions ユーザーが選択できるリストオプション
    */
    displayChuteLabels(value, chuteSelectOptions) {
      const indexOf = chuteSelectOptions.findIndex(chute => chute.value === value)
      let layer = 'レイヤー'
      if (indexOf !== -1) {
        const chuteLabel = chuteSelectOptions[indexOf].text
        if (chuteLabel && chuteLabel < 10) {
          layer += '0'
        }
        layer += chuteLabel
        return layer
      }
      return layer
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonUtils.js